import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/redenvelopes.png';

const _withScopeId = n => (_pushScopeId("data-v-b46bad74"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "recom-mend"
};
const _hoisted_2 = {
  class: "recom-posterc"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "posterc-img-element"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "rule-img",
  alt: ""
})], -1));

const _hoisted_4 = {
  class: "posterc-rule"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "rule-span"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "https://mp.weixin.qq.com/s/eqMWZB8g-LkJJnK2PPNWkw",
  class: "rule-a"
}, "推荐返佣规则")], -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "inset-title"
}, " 填写信息 ", -1));

const _hoisted_7 = {
  class: "choice-element-content"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1,
  class: "choice-color-000"
};
const _hoisted_10 = {
  class: "choice-element-content"
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  key: 1,
  class: "choice-color-000"
};
const _hoisted_13 = {
  class: "recom-checkbox-element"
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "element-checkbox-span"
}, "我已阅读并同意", -1));

import { onMounted, reactive, ref } from 'vue';
import { verification } from './type';
import RecomBottomContent from '@/views/recommend/component/RecomBottomContent.vue';
import VerifiCationOpen from '@/views/recommend/component/VerifiCationOpen.vue';
import EquipmentSelection from '@/views/recommend/component/EquipmentSelection.vue';
import SelectCity from '@/views/components/SelectCity.vue';
import { addClue } from '@/api';
import { useRoute } from 'vue-router';
import router from '@/router';
import { useRouteKeepAliveRefreshPage } from '@/router/useRouteKeepAliveRefreshPage';
import DeclareToast from '@/views/components/DeclareToast.vue';
import { reportEvent } from '@/utils/buried-point';
export default /*#__PURE__*/_defineComponent({
  __name: 'RecomMend',

  setup(__props) {
    reportEvent('RecommendH5PageView');
    const statr = reactive({
      ecommenderPhone: '',
      buyerName: '',
      buyerPhone: '',
      city: '',
      equipment: ''
    });
    const checked = ref(false);
    const display = ref(false);
    onMounted(() => {
      window.document.title = '邀好友 赚佣金'; // console.log('RecomMend', useRoute().query.origin);
    });
    const verifiShow = ref(false);
    const popupShow = ref(false);
    const cityShow = ref(false);

    const submit = () => {
      console.log(checked.value);

      if (verification(statr, checked.value)) {
        verifiShow.value = true;
      }
    };

    const onVerifiClose = () => {
      verifiShow.value = false;
      notifi.value = false;
    };

    const origin = useRoute().query.origin;
    const recommended = reactive({
      firstCityCategoryList: '',
      secondCityCategoryList: '',
      thirdCityCategoryList: '',
      moDeId: null,
      cityId: ''
    });
    const notifi = ref(false);

    const onConfirmSelection = (data, moDeId) => {
      statr.equipment = data.equipmentName + '-' + data.equipmentSize + '-' + data.equipmentModel;
      recommended.moDeId = moDeId && moDeId;
      popupShow.value = false;
    };

    const onConfirm = (data, val) => {
      console.log(data);
      const {
        firstCityCategoryList,
        secondCityCategoryList,
        thirdCityCategoryList
      } = data;
      statr.city = `${firstCityCategoryList}-${secondCityCategoryList} ${thirdCityCategoryList ? '-' : ''} ${thirdCityCategoryList}`;
      recommended.firstCityCategoryList = firstCityCategoryList;
      recommended.secondCityCategoryList = secondCityCategoryList;
      recommended.thirdCityCategoryList = thirdCityCategoryList;
      recommended.cityId = val.map(item => {
        return item.id;
      }).join(',');
      console.log(recommended.cityId);
      cityShow.value = false;
    };

    const onRecommendedconfirm = async code => {
      try {
        display.value = true;
        const {
          firstCityCategoryList,
          secondCityCategoryList,
          thirdCityCategoryList,
          moDeId,
          cityId
        } = recommended;
        const query = {
          accountName: statr.buyerName,
          accountMobile: statr.buyerPhone,
          referrerMobile: statr.ecommenderPhone,
          num: 1,
          province: firstCityCategoryList,
          city: secondCityCategoryList,
          area: thirdCityCategoryList,
          deviceId: moDeId,
          cityId: cityId,
          note: '',
          type: 'device',
          userId: 0,
          categoryFullname: `${firstCityCategoryList}-${secondCityCategoryList}-${thirdCityCategoryList}`,
          origin: origin ? Number(origin) : 1,
          verificationCode: code,
          customerType: '',
          estimatePurchaseTime: '',
          purchaseBudget: ''
        };
        const res = await addClue(query);

        if (res.code === 200) {
          _Toast('提交成功');

          notifi.value = true;
        } else {
          _Toast(res.msg);
        }

        display.value = false; // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (error) {
        _Toast(error.response.data.msg);

        display.value = false;
      }
    }; // 此方法可以执行初始化数据


    useRouteKeepAliveRefreshPage(['useragreement'], () => {
      return null;
    });

    const onAgreement = () => {
      router.push({
        path: '/useragreement'
      });
    };

    const onShare = () => {
      var aux = document.createElement('input');
      aux.setAttribute('value', window.location.href);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand('copy');
      document.body.removeChild(aux);

      _Toast('链接复制成功');
    };

    return (_ctx, _cache) => {
      const _component_icon_payment_keyhead = _resolveComponent("icon-payment-keyhead");

      const _component_van_field = _resolveComponent("van-field");

      const _component_icon_payment_rightkeyhead = _resolveComponent("icon-payment-rightkeyhead");

      const _component_van_checkbox = _resolveComponent("van-checkbox");

      const _component_van_cell_group = _resolveComponent("van-cell-group");

      const _component_van_overlay = _resolveComponent("van-overlay");

      const _component_van_popup = _resolveComponent("van-popup");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("nav", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_icon_payment_keyhead, {
        class: "icon"
      })]), _createElementVNode("div", {
        class: "recom-share",
        onClick: onShare
      })]), _createVNode(_component_van_cell_group, {
        inset: ""
      }, {
        default: _withCtx(() => [_hoisted_6, _createVNode(_component_van_field, {
          modelValue: statr.ecommenderPhone,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => statr.ecommenderPhone = $event),
          type: "number",
          placeholder: "请输入您的手机号"
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: statr.buyerName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => statr.buyerName = $event),
          placeholder: "请输入购机人的姓名"
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: statr.buyerPhone,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => statr.buyerPhone = $event),
          type: "number",
          placeholder: "请输入购机人的手机号"
        }, null, 8, ["modelValue"]), _createElementVNode("div", {
          class: "recom-choice-element",
          onClick: _cache[3] || (_cache[3] = $event => cityShow.value = true)
        }, [_createElementVNode("span", _hoisted_7, [!statr.city ? (_openBlock(), _createElementBlock("span", _hoisted_8, "请选择城市")) : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(statr.city), 1))]), _createVNode(_component_icon_payment_rightkeyhead, {
          class: "icon"
        })]), _createElementVNode("div", {
          class: "recom-choice-element",
          onClick: _cache[4] || (_cache[4] = $event => popupShow.value = true)
        }, [_createElementVNode("span", _hoisted_10, [!statr.equipment ? (_openBlock(), _createElementBlock("span", _hoisted_11, "请选择设备、型号")) : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(statr.equipment), 1))]), _createVNode(_component_icon_payment_rightkeyhead, {
          class: "icon"
        })]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_van_checkbox, {
          modelValue: checked.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => checked.value = $event),
          "checked-color": "#FE4156",
          class: "element-checkbox"
        }, {
          default: _withCtx(() => [_hoisted_14, _createElementVNode("span", {
            class: "element-checkbox-a",
            onClick: onAgreement
          }, "《机惠宝用户协议》")]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", {
          class: "recom-btn-element"
        }, [_createElementVNode("button", {
          class: "recom-btn",
          onClick: submit
        }, "我要推荐")])]),
        _: 1
      }), _createVNode(RecomBottomContent), _createVNode(_component_van_overlay, {
        show: verifiShow.value
      }, {
        default: _withCtx(() => [_createVNode(VerifiCationOpen, {
          show: verifiShow.value,
          phone: statr.ecommenderPhone,
          "notifi-show": notifi.value,
          onClose: onVerifiClose,
          onConfirm: onRecommendedconfirm
        }, null, 8, ["show", "phone", "notifi-show"])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_popup, {
        show: popupShow.value,
        "onUpdate:show": _cache[7] || (_cache[7] = $event => popupShow.value = $event),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(EquipmentSelection, {
          onClose: _cache[6] || (_cache[6] = $event => popupShow.value = false),
          onConfirm: onConfirmSelection
        })]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_popup, {
        show: cityShow.value,
        "onUpdate:show": _cache[9] || (_cache[9] = $event => cityShow.value = $event),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(SelectCity, {
          onClose: _cache[8] || (_cache[8] = $event => cityShow.value = false),
          onConfirm: onConfirm
        })]),
        _: 1
      }, 8, ["show"]), display.value ? (_openBlock(), _createBlock(DeclareToast, {
        key: 0,
        show: display.value
      }, null, 8, ["show"])) : _createCommentVNode("", true)]);
    };
  }

});